import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import DevicesGrid from "./DevicesGrid";

export default function DevicesMenu({onClose}:{onClose: () => void}) {

  const { t } = useTranslation();
  return (
    <>
      <div className="flex flex-row items-center px-6">
        <NavLink to={"/data/devices"} onClick={onClose}><div className="text-base font-semibold flex h-14 items-center">{t("devices")}</div></NavLink>
      </div>
      <DevicesGrid onClose={onClose}/>
    </>
  )
}


